import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  submit(event) {
    if (event.target.matches('input[type="radio"][name="range"]')) {
      this.element
        .querySelectorAll('input[name="from"], input[name="to"]')
        .forEach((field) => {
          field.value = "";
        });
    } else if (event.target.matches('input[name="from"], input[name="to"]')) {
      const customRadio = this.element.querySelector(
        'input[type="radio"][name="range"]:checked',
      );
      if (customRadio) {
        customRadio.checked = false;
      }
    }
    this.element.requestSubmit();
  }
}
